import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TwitterEmbed from '../../../organisms/TwitterEmbed';
import ThreadsEmbed from '../../../organisms/ThreadsEmbed';
import YouTubeEmbed from '../../../organisms/YouTubeEmbed';
import InstagramCarousel from './InstagramCarousel';

const ArticleModalExternalEmbeds = ({ article, isOpen }) => {
  const embedCode = article.embedCode || '';
  const isVideoNewsEmbed = embedCode.includes('videos.globo.com') || embedCode.includes('record.r7.com');
  const isSpotifyEmbed = embedCode.includes('spotify.com');

  return (
    <>
      <TwitterEmbed article={article} isOpen={isOpen} />

      {article.mediaType === 'Instagram' && (
        <InstagramCarousel article={article} />
      )}

      <ThreadsEmbed article={article} isOpen={isOpen} />

      <YouTubeEmbed article={article} />

      {isVideoNewsEmbed && (
        <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
          <Box
            dangerouslySetInnerHTML={{ __html: article.embedCode }}
            sx={{
              width: '100%',
              maxWidth: '720px',
              '& iframe': {
                width: '100%',
                aspectRatio: '16/9',
                borderRadius: '8px',
                border: 'none'
              }
            }}
          />
        </Box>
      )}

      {isSpotifyEmbed && (
        <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
          <Box
            dangerouslySetInnerHTML={{ __html: article.embedCode }}
            sx={{
              width: '100%',
              maxWidth: '720px',
              '& iframe': {
                width: '100%',
                minHeight: article.embedCode.includes('/video') ? '352px' : '152px',
                borderRadius: '12px',
                border: 'none'
              }
            }}
          />
        </Box>
      )}
    </>
  );
};

ArticleModalExternalEmbeds.propTypes = {
  article: PropTypes.shape({
    embedCode: PropTypes.string,
    mediaType: PropTypes.string
  }).isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default ArticleModalExternalEmbeds;
